import React, { FC, Suspense } from "react";

import { KFThumbnailGenerator, KModal, KModalHeader } from "@keepeek/refront-components";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { KIcon } from "../../components/common/KIcon";
import { thumbnailGeneratorModalState } from "./atom";

const ThumbnailGeneratorModal: FC = function () {
  const { t } = useTranslation();
  const [thumbnailGeneratorModal, setThumbnailGeneratorModal] = useRecoilState(
    thumbnailGeneratorModalState,
  );
  if (!thumbnailGeneratorModal) {
    return null;
  }
  const handleClose = () => setThumbnailGeneratorModal(undefined);
  return (
    <KModal
      testId="ThumbnailGeneratorModal"
      id="ThumbnailGeneratorModal"
      open={true}
      onClose={handleClose}
      header={<KModalHeader onClose={handleClose} title={t("thumbnail-generator-modal.title")} />}
      sx={{
        // we configure the zIndex in order to be able to display the KFThumbnailGenerator drawer (in response mode) above the modal
        zIndex: (theme) => theme.zIndex.drawer - 1,
        ["& .KModal-body"]: {
          padding: 0,
          height: "100%",
        },
        ["& .KModal-content"]: {
          width: "95vw",
          height: "91vh",
          maxWidth: "none",
          display: "grid",
          gridTemplate: "auto minmax(0,100%) / 1fr",
        },
        ["& .KModal-scrollBox"]: {
          padding: "4vh 0",
        },
      }}
    >
      <Suspense
        fallback={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <KFThumbnailGenerator elementId={thumbnailGeneratorModal} KIcon={KIcon} />
      </Suspense>
    </KModal>
  );
};

export default ThumbnailGeneratorModal;
